"use client";
import React, { useState } from "react";
import "./product.css";

export default function Product() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "Paint Protection Film",
      answer: [
                "SS BaseShield Paint Protection Film – 3 Years" ,
                "SS DuraShield Paint Protection Film – 5 Years",
                "SS LumiShield Paint Protection Film - 6 Years",
                "SS NeoShield Paint Protection Film - 8 Years",
                "SS EternaShield Paint Protection Film - 10 Years",
        
      ],
    },
    {
      question: "Sunroof & Headlight Film",
      answer: [
        "SS Head Light Protection Film (250 Sq Ft)",
        "SS Sunroof Film Heat Resistance",
      ],
    },
    {
      question: "Ceramic Coating",
      answer: ["SS Ceramic Coating 9H", "SS Ceramic Details Spray", "SS Glass Coating","SS Ceramic Coating Kit"],
    },
    {
      question: "Graphene Coating",
      answer: ["SS Graphene Coating 10H", "SS Graphene Details Spray","SS Graphene Coating Kit"],
    },
    {
      question: "Shampoos & Cleaner Solvents",
      answer: [
        "SS Wash & Shine Shampoo",
        "SS D'greaser",
        "SS Interior Cleaner",
        "SS Interior Wash",
        "SS Multipurpose Cleaner",
        "SS Spray & Wipe",
        "SS Alloy Wheel Cleaner",
      ],
    },
    {
      question: "Compound, Waxes and Polishes",
      answer: ["SS Car Polish", "SS Wax Polish", "SS Driwash ‘n’ Guard"],
    },
    {
      question: "Dressing & Glass Treatment",
      answer: [
        "SS Glass Cleaner",
        "SS Dashboard Polish",
        "SS Multipurpose Shiner",
        "SS Tyre Shiner",
        "SS Anti-Fog ",
        "SS Windshield Washer",
      ],
    },
    {
      question: "Underbody & Internal Panel Protection",
      answer: [
        "SS Antirust Underbody Coating - Black",
        "SS Antirust Underbody Coating - Clear",
        "SS Cavity Protection Spray",
      ],
    },
    {
      question: "Odor Elimination",
      answer: ["SS Odor Neutralizer"],
    },
    {
      question: "Professional Kit",
      answer: [
        "SS Car Care Kit",
        "SS Car Wax Kit",
        "SS Head Light Restoration Kit",
      ],
    },
    {
      question: "Accessories",
      answer: [
        "SS Door Edge Guard",
        "SS Professional Microfibre Towel",
        "SS Seat Cover - Non Woven (3 Pcs)",
      ],
    },
    {
      question: "Technical Solutions",
      answer: [
        "SS Clean Plus - For Engines",
        "SS Cooling System Flush",
        "SS DC-5 - Fuel System Cleaner",
        "SS DIC - Diesel Injector Cleaner",
        "SS Diesel EISC",
        "SS DISC - Diesel Injection System Cleaner",
        "SS FR-VII - Premium Oil Treatment",
        "SS Fuel System Tune UP",
        "SS Gas UP - Fuel Injector Cleaner",
        "SS Intake Air System Cleaner",
        "Fuel Injection Tool - FIT",
        "Diesel Injection Tool - DIT",
        "Air Intake Cleaning Tool",
      ],
    },
    {
      question: "Aerosols",
      answer: [
        "SS All Purpose Shiner",
        "SS Anti-Rust Underbody Coating - Black",
        "SS Battery Terminal Protectant",
        "SS Brake Parts Cleaner",
        "SS Cabin Disinfectant",
        "SS Chain Cleaner",
        "SS Chain Lube",
        "SS Electrical Contact Cleaner",
        "SS Engine Lacquer Coating",
        "SS Frigi Foam - AC Vent Cleaner",
        "SS Instant Rust Off",
        "SS Premium Multipurpose Grease",
        "SS Silencer Coating - Black",
        "Silencer Coating - Zinc",
        "SS Silicone Spray",
        "SS Throttle Body & Intake Cleaner",
        "SS Upholstery Foam Cleaner",
        "SS Wheel Drum Paint",
        "SS Cavity Protection Spray",
      ],
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <section className="ProductSection">
        <div className="overlay"></div>

        <div className="ProductContent text-center mt-5">
          {/* <h1>Product Offering</h1> */}

          <div className="faq-section container mt-5 mb-5">
            {/* <h2 className="faq-title">Product Offerings</h2> */}

            <div className="faq-container">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className={`faq-item ${activeIndex === index ? "active" : ""}`}
                >
                  <button
                    className="faq-question"
                    onClick={() => toggleFAQ(index)}
                  >
                    {faq.question}
                    <span className="icon">
                      {activeIndex === index ? "–" : "+"}
                    </span>
                  </button>
                  <div
                    className="faq-answer"
                     style={{
    maxHeight: activeIndex === index ? "fit-content" : "0",
    overflow: "hidden",
    transition: "all 0.5s ease",
    padding: activeIndex === index ? "10px 0" : "0",
  }}
                  >
                    <ul className="faq-list">
                      {faq.answer.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
